<!-- @format -->
<script lang="ts">
   import type { ManageAPI } from "~/manage-api/types";
  import { getStoresContext } from "~/stores";
  import type { StoresKey } from "~/stores";
  import StoreCard from "./StoreCard.svelte";
  import FilterByLob from "./FilterByLOB.svelte";
  import FilterByFloor from "./FilterByFloor.svelte";
  import FilterBySearchValue from "./FilterBySearchValue.svelte";
  import { getFragmentConfigOr, valueGetters } from "~/components/field-utils";
  import Button from "../Button.svelte";
  import { filterStores, groupByInitial } from "~/util/store";
  import { getFobs, findFobByQuery } from "../../utils";

  export let request_store_key: StoresKey;
  export let fragment: Fragment;

  const { scdata, stores, reverse_router, T, locale, site_groupings } = getStoresContext(request_store_key);
  const stores_context = getStoresContext(request_store_key);
  const { getText} = valueGetters(stores_context);

  let strictNoFilterDisplay = getFragmentConfigOr("strictNoFilterDisplay", fragment, false);
  $: defaultFob = $locale && getText("defaultFob", fragment);

  let fieldsOfBusiness: ManageAPI.Fob[] | Grouping[] = [];
  $: if ($scdata && $site_groupings && $stores) {
    ( {fieldsOfBusiness} = getFobs($site_groupings, false, $stores, true, $scdata) );
  }

  $: if(defaultFob) {
    let foundFob = findFobByQuery(defaultFob, fieldsOfBusiness);
    if(foundFob) changeCategory({detail:foundFob});
  }
  let search_value: string = "";
  let current_floor: string = "";
  let current_fob: string | Grouping = "";

  $: stores_by_initial = $locale ? groupByInitial(
        filterStores(
          $stores,
          search_value,
          current_floor,
          current_fob
        ),
        $locale
      ) : [];

  $: showFloorFilter = $stores.reduce((acc, store) => {
    if (store.floor?.id) acc.add(store.floor.id);
    return acc;
  }, new Set()).size > 1;

  function search(event: CustomEvent): string {
    return search_value = event.detail;
  }

  function changeFloor(event: CustomEvent): string {
    return current_floor = event.detail;
  }

  function changeCategory(event: CustomEvent): string {
    return current_fob = event.detail;
  }

  $: href = $reverse_router.routePurpose("floor map");
  $: t = $T;
</script>
<section class="section pb-5">
  {#if !strictNoFilterDisplay}
    <div class="row">
      <div class="col-lg-3 col-6">
        <FilterByLob {request_store_key} on:changeCategory={changeCategory} />
      </div>
      {#if showFloorFilter}
        <div class="col-lg-3 col-6">
          <FilterByFloor
            stores={$stores}
            {request_store_key}
            on:changeFloor={changeFloor} />
        </div>
      {/if}
      <div class="col-lg-3 col-12">
        <FilterBySearchValue {request_store_key} on:search={search} />
      </div>
      <div class="col-lg-3 col-12">
        {#if href}
          <Button {href} type="secondary">{t`floor map`}</Button>
        {/if}
      </div>
    </div>
  {/if}
</section>
{#if stores_by_initial.length}
  {#each stores_by_initial as letter}
    <div class="row mb-sm-5 mb-4">
      <div class="col-12">
        <h3 class="mb-sm-5 mb-4 letter">{letter.name}</h3>
      </div>
      {#each letter.stores as store}
        <div class="col-md-4 col-lg-3 col-6 mb-5">
          <StoreCard
            href={$reverse_router.routeStore(store, $scdata)}
            {store}
            {request_store_key} />
        </div>
      {/each}
    </div>
  {/each}
{:else}
  <div class="row">
    <h2 class="col-12 text-center mb-sm-5 mb-4">
      {t`your search did not match any results`}
    </h2>
  </div>
{/if}
<style>
  .letter {
    font-size: 48px;
    font-weight: 500;
  }
</style>
